export const LANGUAGE_STORAGE_KEY = "app_language";
export const DEFAULT_LANGUAGE = "en";
export const RTL_LANGUAGES = ["ar"];

export const LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "ar", label: "العربية" },
  { value: "fr", label: "Français" },
];

export const SUPPORTED_LANGUAGES = LANGUAGE_OPTIONS.map((option) => option.value);
